import { render, staticRenderFns } from "./ExcepcionesView.vue?vue&type=template&id=21cbb77b&scoped=true&lang=pug"
import script from "./ExcepcionesView.vue?vue&type=script&lang=js"
export * from "./ExcepcionesView.vue?vue&type=script&lang=js"
import style0 from "./ExcepcionesView.vue?vue&type=style&index=0&id=21cbb77b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cbb77b",
  null
  
)

export default component.exports